<!--  BEGIN CONTENT PART  -->
<div id="content" class="main-content">
    <div class="alert alert-gradient" id="successSave" role="alert" style="opacity: 0;position: fixed;z-index: 100;display: none;"> 
        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
        <strong>Succes </strong> Visite planifiée  </div>
    <div class="alert alert-gradient alert-danger" id="error" role="alert" style="opacity: 0;position: fixed;z-index: 100;
        display: none;background-image: linear-gradient(135deg,#8f3038ed 0,#e6000cc4 100%) !important;"> 
        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
        <strong>Echouée</strong> Erreur lors de la planification de la visite</div>
    <div class="alert alert-gradient" id="reviveSuccess" role="alert" style="opacity: 0;position: fixed;z-index: 100;display: none;"> 
        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
        <strong>Envoyée </strong> La relance de la semaine est envoyée avec succès </div>
    <div class="alert alert-gradient alert-danger" id="reviveError" role="alert" style="opacity: 0;position: fixed;z-index: 100;
        display: none;background-image: linear-gradient(135deg,#8f3038ed 0,#e6000cc4 100%) !important;"> 
        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
        <strong>Echouée</strong> La relance de la semaine n'est pas envoyée !</div>
    <div class="container">
        <div class="page-header">
            <div class="page-title">
                <h2><b>Visites</b></h2>
            </div>
        </div>
        <div class="row" *ngIf="role == 'adm'">
            <div class="col-xl mb-xl-0 col-lg-4 mb-4 col-md-6 col-sm-6" id="left">
                <div class="widget-content-area  data-widgets br-4">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-order-widget">
                        <div class="media">
                            <div class="icon ml-2" style="max-width: fit-content;">
                                <i class="flaticon-loading-1" style="background-color: #eedab9;color: black;"></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">En attente de validation</p>
                                <p class="widget-numeric-value">{{onDecision}} Visites</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl mb-xl-0 col-lg-4 mb-4 col-md-6 col-sm-6" id="left">
                <div class="widget-content-area  data-widgets br-4">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-order-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-calendar" style="background-color: #5ad7ff;color: black;"></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">Planifiées</p>
                                <p class="widget-numeric-value">{{planned}} Visites</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl mb-xl-0 col-lg-4 mb-4 col-md-6 col-sm-6" id="right">
                <div class="widget-content-area  data-widgets br-4">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-customer-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-car"></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">En cours</p>
                                <p class="widget-numeric-value">{{inProgress}} Visites</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl mb-xl-0 col-lg-4 mb-4 col-md-6 col-sm-6" id="right">
                <div class="widget-content-area  data-widgets br-4">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;
                                        margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-customer-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-single-tick" style="background-color: #61a4fd;color: white;" ></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">Effectuées</p>
                                <p class="widget-numeric-value">{{done}} visites</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl mb-xl-0 col-lg-4 mb-4 col-md-6 col-sm-6" id="right">
                <div class="widget-content-area  data-widgets br-4 p-3">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;
                                        margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-customer-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-calendar-1" style="background-color: #e99f9f;color: white;"></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">Reportées</p>
                                <p class="widget-numeric-value mb-0">{{reported}} Visites</p>
                            </div>
                        </div>
                        <p class="mb-0" style="color: #da0000;">Visites annulées <b>{{canceled}}</b></p>
                        <p style="color: #e27c07;">Visites archivées <b>{{archived}}</b></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" id="father">
            <div class="text-left col-lg-6 mx-md-auto" id="btn">
                <a *ngIf="role == 'adm'" type="button" class="btn btn-gradient-dark mb-4 mr-2" href="/newVisit" routerLink="/newVisit">
                    <i class="flaticon-plus-1 mr-2"></i> Nouvelle visite</a>
            </div>
            <div class="text-right col-lg-6 mx-md-auto " id="btn">
                <a type="button" class="btn btn-gradient-dark mb-4 mr-2 relance" href="javascript:void(0)"
                    [ngClass]="{'disable-revive': noPlan == 0 }" (click)="openRelaunchModal()"
                    style="background-image: linear-gradient(to right,#47adfa 0,#517fa4 100%);" 
                    data-toggle="modal" data-target="#relaunchModal" >
                    <img src="../../../assets/img/suivitim_img/new_visits.gif" alt="" style="width:23px"> 
                    Relancer mon équipe ({{noPlan}}<span *ngIf="noPlan>1"> Commerciaux</span>
                    <span *ngIf="noPlan==1"> Commercial</span>)
                    <div *ngIf="loadingReviveCommercials" class="spinner-border text-dark" role="status" style="width: 20px !important;
                        height: 20px !important;">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span *ngIf="successRelance==1" style="font-size: smaller;
                        color: aqua;">Envoyée</span>
                    <span *ngIf="successRelance==2" style="font-size: smaller;
                        color: #ff7070;">Echouée</span>
                </a>
            </div>
        </div>
        <div class="row" id="cancel-row" *ngIf="!visitsLoading">
            <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                <div class="statbox widget box box-shadow">
                    <div class="widget-header">
                        <div class="row">       
                        </div>
                    </div>
                    <div class="widget-content widget-content-area">
                        <div class="table-responsive mb-4">
                            <div class="row col-lg-3">
                                <div class="custom-control rounded-chk custom-checkbox checkbox-primary mt-2" style="margin: auto;"
                                    [class.inactive-filter]="showRefused"
                                    *ngIf="user?.roles?.includes('CLIENT_CONSULTATION_ARCHIVE')">
                                    <input type="checkbox" class="custom-control-input" id="archivedVisits"
                                        [checked]="showArchived" (click)="archivedVisits($event)">
                                    <label class="custom-control-label" for="archivedVisits">Visites archivées</label>
                                </div>
                                <div class="custom-control rounded-chk custom-checkbox checkbox-primary mt-2" style="margin: auto;"
                                    [class.inactive-filter]="showArchived"
                                    *ngIf="user?.roles?.includes('CLIENT_CONSULTATION_ARCHIVE')">
                                    <input type="checkbox" class="custom-control-input" id="refusedVisits"
                                        [checked]="showRefused" (click)="refusedVisits($event)">
                                    <label class="custom-control-label text-danger" for="refusedVisits">Visites refusées</label>
                                </div>
                            </div>
                            <div *ngIf="loading_visit" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;
                                        margin-bottom: 20%;"></div>
                            <table *ngIf="!loading_visit" id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Visite</th>
                                        <th>Client/Prospect</th>
                                        <th>Secteur</th>
                                        <th>Date visite</th>
                                        <th>Ville</th>
                                        <th>Affectée à</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let client of visit" id="{{client.visit}}">
                                        <td [ngClass]="{'archived_bg': client.visit_archived}">
                                            <a href="visite/detail/it;cr={{client.visit}}" (click)="MarkAsRead(client.visit)">
                                            <b class="text-primary">{{client.visit_code}}</b>
                                        </a></td>
                                        <td [ngClass]="{'priorise': client.visit_status==='En attente de validation'}"
                                            [ngClass]="{'archived_bg': client.visit_archived}">
                                            <a [attr.href]="'/customer/fromshow;cs='+client.visit_customer_uuid" class="mr-2 action_plan_unique customer" title="Voir détail client">
                                                {{client.visit_customer}}
                                            </a>
                                            <a href="javascript:void(0)" *ngIf="client.visit_status=='Terminée'" 
                                                class="text-primary" (click)="Pdf(client?.visit)">
                                                <i class="flaticon-copy-line"></i>
                                                <span class="mb-1 ml-1" style="font-size:x-small;">Rapport</span>
                                            </a>
                                        </td>
                                        <td [ngClass]="{'priorise': client.visit_status==='En attente de validation'}"
                                            [ngClass]="{'archived_bg': client.visit_archived}">
                                            {{client.visit_sector || '----'}}
                                        </td    >
                                        <td id="date{{client.visit}}" [ngClass]="{'priorise': client.visit_status==='En attente de validation'}"
                                            [ngClass]="{'archived_bg': client.visit_archived}">
                                            <span *ngIf="client.visit_planned_at == null">Non planifiée</span>
                                            {{client.visit_planned_at | date: 'dd/MM/yyyy'}}</td>
                                        <!-- <td [ngClass]="{'priorise': client.visit_status==='En attente de validation'}">{{client.visit_customer_address}}</td> -->
                                        <td [ngClass]="{'priorise': client.visit_status==='En attente de validation'}"
                                            [ngClass]="{'archived_bg': client.visit_archived}">{{client.visit_customer_city}}</td>
                                        <td [ngClass]="{'priorise': client.visit_status==='En attente de validation'}"
                                            [ngClass]="{'archived_bg': client.visit_archived}">{{client.visit_affected_to}}</td>
                                        <td [ngClass]="{'priorise': client.visit_status==='En attente de validation'}"
                                            [ngClass]="{'archived_bg': client.visit_archived}">
                                            <div class="" id="status{{client.visit}}">
                                                <span *ngIf="client.visit_status=='Terminée'" style="display: inline-flex;">
                                                    <span class="dot dot-success align-self-center mr-2"></span> Effectuée</span>
                                                <span *ngIf="client.visit_status=='En attente de validation'" style="display: inline-flex;">
                                                    <span class="dot dot-inprogress align-self-center mr-2" 
                                                        style="background-color: gray !important;font-size: small;"></span> En attente de validation</span>
                                                <span *ngIf="client.visit_status=='Refusée'" style="display: inline-flex;" class="text-danger">
                                                    <span class="dot dot-annule align-self-center mr-2"></span> Refusée</span>
                                                <span *ngIf="client.visit_status=='En cours'" style="display: inline-flex;">
                                                    <span class="dot dot-inprogress align-self-center mr-2"></span> En cours</span>
                                                <span *ngIf="client.visit_status=='Reportée'" style="display: inline-flex;">
                                                    <span class="dot dot-danger align-self-center mr-2"></span> Reportée</span>
                                                <span *ngIf="client.visit_status=='Planifiée'" style="display: inline-flex;">
                                                    <span class="dot dot-planifie align-self-center mr-2"></span> Planifiée</span>
                                                <span *ngIf="client.visit_status=='Créée'" style="display: inline-flex;">
                                                    <span class="dot dot-info align-self-center mr-2"></span> Créée</span>
                                                <span *ngIf="client.visit_status=='Annulée'" style="display: inline-flex;">
                                                    <span class="dot dot-annule align-self-center mr-2"></span> Annulée</span>
                                                <span *ngIf="client.visit_status=='Brouillon'" style="display: inline-flex;">
                                                    <img src="assets/img/suivitim_img/finalisation.gif" style="width: 20px;"> Finalisation ...</span>
                                            </div></td>
                                        <td class="text-center" [ngClass]="{'priorise': client.visit_status==='En attente de validation', 'archived_bg': client.visit_archived}">
                                            <div *ngIf="processingVisitUuid === client.visit" class="spinner-border spinner-border-sm text-primary" role="status">
                                                <span class="sr-only">Traitement en cours...</span>
                                            </div>
                                            <div class="dropdown custom-dropdown" *ngIf="processingVisitUuid !== client.visit">
                                                <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="true" *ngIf="client.visit_status!='Brouillon' && client.visit_status!='En cours'">
                                                    <i class="flaticon-dot-three"></i>
                                                </a>
                                                <a href="javascript:void(0)" *ngIf="client.visit_status=='Terminée'"
                                                    class="text-primary" (click)="Pdf(client?.visit)">
                                                    <i class="flaticon-copy-line"></i>
                                                </a>
                                                <a class="dropdown-toggle" href="javascript:void(0)" role="button" id="dropdownMenuLink1"
                                                    *ngIf="client.visit_status=='Brouillon' || client.visit_status=='En cours'">
                                                    <i class="flaticon-dot-three" style="color: rgb(218, 218, 218);"></i>
                                                </a>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                    <a class="dropdown-item" href="visite/detail/it;cr={{client.visit}}" (click)="MarkAsRead(client.visit)"
                                                        *ngIf="client.visit_status!='Brouillon'">Consulter</a>
                                                    <a class="dropdown-item" href="javascript:void(0)" *ngIf="isDescriptionEditable(client)"
                                                        data-toggle="modal" data-target="#editDescriptionModal" (click)="openEditDescription(client)">Modifier</a>
                                                    <a class="dropdown-item" href="javascript:void(0)" *ngIf="client.visit_status=='En attente de validation' && role == 'adm'" 
                                                        data-toggle="modal" data-target="#validateVisit" (click)="getVisitToValidate(client)">Valider</a>
                                                    <a class="dropdown-item" href="javascript:void(0)" *ngIf="client.visit_status=='En attente de validation' && role == 'adm'"
                                                        data-toggle="modal" data-target="#refuseVisit" (click)="getVisitToValidate(client)">Refuser</a>
                                                    <a class="dropdown-item" href="javascript:void(0);" data-toggle="modal" data-target="#planifiermodal"
                                                    (click)="getTeamid(client)" *ngIf="client.visit_status=='Créée' && role == 'adm'">Planifier</a>
                                                    <a class="dropdown-item"  href="javascript:void(0);" data-toggle="modal" data-target="#planifiermodal"
                                                        (click)="getTeamid(client)" *ngIf="(client.visit_status=='Planifiée' || client.visit_status=='Reportée' || client.visit_status=='Annulée') && role == 'adm'">
                                                        Replanifier</a>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                            </table>
                        </div>
                    </div>
                </div>    
            </div>
        </div>
    <!-- <div id="historymodal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"> <b>Historique des actions</b></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                    <div class="modal-body">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-content widget-content-area area_popin">
                                <div class="media table-responsive">
                                    <table id="alter_paginations" class="table table-striped table-bordered" style="width:100%">
                                        
                                        <thead >
                                            <tr>
                                                <th>Commercial</th>
                                                <th>Action</th>
                                                <th>Client</th>
                                                <th>Date action</th>
                                                <th>Ajoutée par</th>
                                                <th>Date d'ajout</th>
                                                <th>Status action</th> 
                                                <th>Status Visite</th>     
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let history of action" >
                                                <td>{{history.action_added_by}}</td>
                                                <td>{{history.action_description}}</td>
                                                <td>{{history.action_added_to_customer}}</td>
                                                <td>
                                                    <span *ngIf="history.action_added_at == null">---</span>
                                                    {{history.action_added_at | date: 'dd/MM/yyyy - HH:mm '}}
                                                </td>
                                                <td>{{history.action_added_by}}</td>
                                                <td>
                                                    <span *ngIf="history.action_added_at == null">---</span>
                                                    {{history.action_added_at | date: 'dd/MM/yyyy - HH:mm '}}
                                                </td>
                                                <td>
                                                    <div class="text-center">
                                                        <b>
                                                            <span *ngIf="history.action_status=='Fait'" class="text-success">{{history.action_status}}</span>
                                                            <span *ngIf="history.action_status=='En cours'" class="text-primary">{{history.action_status}}</span>
                                                            <span *ngIf="history.action_status=='Non fait'" class="text-warning">{{history.action_status}}</span>
                                                            <span *ngIf="history.action_status=='- - -'" class="text-danger">{{history.action_status}}</span>
                                                        </b>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div id="status" class="text-center">
                                                        <span *ngIf="history.visit_action_status=='Terminée'" style="display: inline-flex;">
                                                            <span class="dot dot-success align-self-center mr-2"></span>Effectuée</span>
                                                        <span *ngIf="history.visit_action_status=='En attente de validation'" style="display: inline-flex;">
                                                            <span class="dot dot-inprogress align-self-center mr-2" 
                                                                style="background-color: gray !important;font-size: small;"></span>
                                                                En attente de validation</span>
                                                        <span *ngIf="history.visit_action_status=='En cours'" style="display: inline-flex;">
                                                            <span class="dot dot-inprogress align-self-center mr-2"></span>En cours</span>
                                                        <span *ngIf="history.visit_action_status=='Reportée'" style="display: inline-flex;">
                                                            <span class="dot dot-danger align-self-center mr-2"></span>Reportée</span>
                                                        <span *ngIf="history.visit_action_status=='Planifiée'" style="display: inline-flex;">
                                                            <span class="dot dot-planifie align-self-center mr-2"></span>Planifiée</span>
                                                        <span *ngIf="history.visit_action_status=='Créée'" style="display: inline-flex;">
                                                            <span class="dot dot-info align-self-center mr-2"></span>Créée</span>
                                                        <span *ngIf="history.visit_action_status=='Annulée'" style="display: inline-flex;">
                                                            <span class="dot dot-annule align-self-center mr-2"></span>Annulée</span>
                                                        <span *ngIf="history.visit_action_status=='Brouillon'" style="display: inline-flex;">
                                                            <img src="assets/img/suivitim_img/finalisation.gif" style="width: 20px;height: 20px;border: unset;">
                                                             Finalisation ...</span>
                                                    </div>
                                                </td>  
                                            </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center md-button">
                        <button type="button" class="btn btn-default btn-rounded mt-3 mb-3 " data-dismiss="modal">Retour</button>
                    </div>
                </div>
            </div>
    </div> -->
    </div>
    <div id="planifiermodal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
        <div class="modal-dialog modal-md"> 
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Visite de <b>{{fullname_commercial}}</b></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <form [formGroup]="planifierForm" id="date" class="form-group row mb-4 col-lg-12 col-lg-12 col-md-12 col-sm-12 ml-1" 
                style="width: 100%;">
                    <div class="col-lg-4  col-xl-4 col-md-12 col-sm-12 "><h6 style="margin-top: 10%;">Date de visite</h6></div>
                    <div class="col-lg-8  col-xl-8 col-md-12 col-sm-12 col-12"> 
                        <input type="date" min="{{mindate|date: 'dd/MM/yyyy'}}" class="form-control" style="border-radius: 18px;"
                        [ngModel]=""
                                name="planned_date" formControlName="planned_date" [ngClass]="{'is-invalid':planifierForm.get('planned_date')?.touched
                                && planifierForm.get('planned_date')?.invalid}">
                    </div>
                </form>
                <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 10%;
                            margin-bottom: 20%;"></div>
                <div *ngIf="!loading_indicator" class="col-xl-12 col-lg-12 col-sm-12" style="margin-top: 2%;">
                    <div class="col-xl-12 col-lg-12 col-sm-12">
                        <div class=" col-xl-12 col-lg-12 col-sm-12 p-3 border-white rounded bg-light" style="overflow-y:scroll;max-height: 235px;">
                            <h6 style="color: #d14545;">Créneaux pleins</h6>
                            <div style="width: 100%;">
                                <div style="margin-top: 2%;" *ngFor="let creneaux of slots">
                                    <span><i style="color: #d14545;" class="flaticon-danger-4 mr-1"></i>{{creneaux.slot_date | date: 'dd/MM/yyyy - HH:mm '}}
                                    <span>{{creneaux.slot_customer}}</span></span> 
                                </div>
                                <p *ngIf="slots?.length==0">Aucune visite n'est planifiée</p>
                            </div>                 
                        </div>
                        <div class="text-center md-button">
                            <button type="button" class="btn btn-primary btn-rounded mt-3 mb-3 mr-2" (click)="Planifier()" data-dismiss="modal">Planifier</button>
                            <button type="button" class="btn btn-default btn-rounded mt-3 mb-3 " data-dismiss="modal">Retour</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="validateVisit" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="widget-content-area  data-widgets br-4">
                    <div class="widget">
                        <div class="media" style="display:block">
                            <div class="icon ml-2" style="text-align: center;">
                                <i class="flaticon-single-tick text-primary" style="font-size: xxx-large;"></i>
                            </div>
                            <div style="text-align: center; margin-top: 10%;">
                                <b >Êtes-vous sûr de vouloir valider la visite créée par {{commercial_to_validate}} 
                                    pour le client {{customer_to_validate}} ?</b>
                            </div>
                            <div style="margin-top:5%">
                                <div class="mt-6 text-center">
                                    <button class="btn btn-primary btn-rounded mb-0 mt-4 mr-2" (click)="validateVisits(visit_id,'f9ab05454998236921a6b0e281fae632')" 
                                        data-dismiss="modal">Valider la visite</button>
                                </div>
                                <div class="mt-3 text-center">
                                    <button class="btn btn-default btn-rounded mt-0 mb-0" data-dismiss="modal">Retour</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="refuseVisit" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="widget-content-area  data-widgets br-4">
                    <div class="widget">
                        <div class="media" style="display:block">
                            <div class="icon ml-2" style="text-align: center;">
                                <i class="flaticon-cancel-2 text-danger" style="font-size: xxx-large;"></i>
                            </div>
                            <div style="text-align: center; margin-top: 10%;">
                                <b >Êtes-vous sûr de vouloir refuser la visite créée par {{commercial_to_validate}}
                                    pour le client {{customer_to_validate}} ?</b>
                            </div>
                            <div class="text-left mt-3 mr-3 ml-3">
                                <textarea rows="2" class="form-control" style="background-color: #fff1f1;"
                                    placeholder="Saisir le motif de refus" [(ngModel)]="motifRefusVisit"></textarea>
                            </div>
                            <div style="margin-top:5%">
                                <div class="mt-6 text-center">
                                    <button class="btn btn-danger btn-rounded mb-0 mt-4 mr-2" (click)="validateVisits(visit_id,'723634aa8cde73188d4661bb3fe81ce4')"
                                        [disabled]="!motifRefusVisit || !motifRefusVisit.trim()" data-dismiss="modal">Refuser la visite</button>
                                </div>
                                <div class="mt-3 text-center">
                                    <button class="btn btn-default btn-rounded mt-0 mb-0" data-dismiss="modal">Retour</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="editDescriptionModal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Modifier la <b>Description</b></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col-xl-12 col-lg-12 col-sm-12" style="margin-top: 2%;">
                    <div class="form-group mb-3">
                        <label class="col-form-label col-form-label-sm"><b>Description</b><span style="color: red;"><b>*</b></span></label>
                        <textarea class="form-control pl-3 pr-3" rows="4" placeholder="Saisir la description ..."
                            [(ngModel)]="editDescriptionValue" name="editDescriptionValue"></textarea>
                        <div *ngIf="editDescriptionError" class="text-danger mt-1">{{editDescriptionError}}</div>
                    </div>
                    <div class="text-center md-button">
                        <button type="button" class="btn btn-primary btn-rounded mt-3 mb-3 mr-2" (click)="saveEditDescription()"
                            [disabled]="editDescriptionLoading || !isDescriptionValid(editDescriptionValue)">Enregistrer</button>
                        <button type="button" class="btn btn-default btn-rounded mt-3 mb-3" data-dismiss="modal">Retour</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal" id="relaunchModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title">Relancer mon équipe</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Sélectionnez les commerciaux à relancer :</p>

          <!-- Liste des commerciaux avec checkboxes -->
          <div class="commercials-list" style="max-height: 300px; overflow-y: auto;">
            <div class="form-check mb-2" *ngFor="let commercial of commercialsToLaunch">
              <input 
                class="form-check-input" 
                type="checkbox" 
                [id]="commercial.commercial"
                [(ngModel)]="commercial.selected"
                (change)="toggleCommercial(commercial, $event)">
              <label 
                class="form-check-label" 
                [for]="commercial.commercial">
                {{ commercial.commercial_fullname }}
              </label>
            </div>
          </div>

          <!-- Affichage du nombre de sélections -->
          <div class="mt-3 text-muted">
            <small>{{ getSelectedUuids().length }} commercial(aux) sélectionné(s)</small>
          </div>
          
        </div>
        <div class="modal-footer border-0">
          <button 
            type="button" 
            class="btn btn-secondary" 
            data-dismiss="modal" 
            (click)="resetSelections()"
            style="background-color: #6c757d; border-color: #6c757d;">
            Annuler
          </button>
          <button 
            type="button" 
            class="btn btn-primary" 
            (click)="sendReviveToPlan()" 
            data-dismiss="modal"
            [disabled]="selectedCommercialUuids.length === 0">
            Relancer ({{ getSelectedUuids().length }})
          </button>
        </div>
      </div>
    </div>
</div>

<!--  Fiche Client Modal -->
<div id="ficheModal" class="modal animated rotateInDownLeft custo-rotateInDownLeft show text-center"  tabindex="-1" role="dialog" aria-labelledby="exampleSuccessAlertLabel">
    <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
        <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <div class="">
                <i class="flaticon-building-1 mt-5"></i>
                <h4 class="modal-title mt-4 mb-4 rs_customer" id="exampleSuccessAlertLabel">
                    <b *ngIf="!retrieveCustomerLoder">{{selectedCustomer?.customer_rs}}</b>
                </h4>
            </div>
            <div class="row align-items-end">
                <div class="col-lg">
                    <div *ngIf="retrieveCustomerLoder" class="cp-spinner cp-skeleton spinner_messages"></div> 

                    <form id="contact_form" *ngIf="!retrieveCustomerLoder">
                        <div class=" col-lg-12 col-md-12">
                            <div class="row mt-2 col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;text-align: left;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 right_inputs">
                                    <label class="col-lg-6 col-md-6 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);"> 
                                        <b>Secteur :</b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0"> 
                                        <p style="margin-top: 2%;margin-left: 5%;">{{selectedCustomer?.customer_sector}}</p> 
                                    </div>
                                </div>
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 right_inputs">
                                    <label class="col-lg-6 col-md-6 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm pl-0" style="color: rgb(22, 22, 22);">
                                        <b>Représentant:</b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0"> 
                                            <p style="margin-top: 2%;"> <span *ngIf="selectedCustomer?.customer_agent == null">---</span>{{selectedCustomer?.customer_agent}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Adresse & Ville :</b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;">
                                            <span *ngIf="selectedCustomer?.customer_cities == null || selectedCustomer?.customer_cities.length == 0">---</span>
                                            <span *ngIf="selectedCustomer?.customer_address != null && selectedCustomer?.customer_address != ''"> {{selectedCustomer?.customer_address}},</span> 
                                            <span *ngIf="selectedCustomer?.customer_cities != null">
                                                <ng-container *ngFor="let city of selectedCustomer?.customer_cities; let last = last">
                                                    {{ city.name }}{{ last ? '' : ', ' }}
                                                </ng-container>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>N° Téléphone : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;"><span *ngIf="selectedCustomer?.customer_phone == null || selectedCustomer?.customer_phone == ''">---</span>{{selectedCustomer?.customer_phone}}</p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>N° Skype : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;"><span *ngIf="selectedCustomer?.customer_skype == null || selectedCustomer?.customer_skype == ''">---</span>
                                            {{selectedCustomer?.customer_skype}}</p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Classe : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">
                                            <span *ngIf="selectedCustomer?.customerClass == null">---</span>
                                            <b *ngIf="selectedCustomer?.customerClass != null " [ngClass]="{'text-success': selectedCustomer?.customerClass?.refClass == 'Classe A', 
                                            'text-secondary': selectedCustomer?.customerClass?.refClass == 'Classe B',
                                            'text-warning': selectedCustomer?.customerClass?.refClass == 'Classe C',
                                            'text-dark': selectedCustomer?.customerClass?.refClass == 'Classe D' }">
                                                {{selectedCustomer?.customerClass?.refClass}}
                                            </b>
                                        </p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Ajouté le : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">
                                            <span *ngIf="selectedCustomer?.customer_added_at == null">---</span>
                                            {{selectedCustomer?.customer_added_at | date: 'dd-MM-yyyy'}}
                                        </p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Commercial : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">
                                            <span *ngIf="!selectedCustomer?.commercials[0]?.commercial">---</span>
                                            {{selectedCustomer?.commercials[0]?.commercial | titlecase}}
                                        </p> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg">
                    <!-- MESSAGES -->
                    <div>
                        <h4 class="text-primary mb-1" style="margin-left: 2%;color: rgb(22, 22, 22)">Conversation</h4>
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="mail-chat-system">
                                <div class="chat_window">
                                    <div *ngIf="loadingMessages" class="cp-spinner cp-skeleton spinner_messages"></div> 
                                    <p *ngIf="messages?.length==0 && !loadingMessages" class="text-center" style="color:gray;">Aucun message pour ce Client</p>
                                    <ul class="chat-messages pl-0 pt-5" *ngIf="messages.length>0">
                                        <!-- <span *ngFor="let message of messages"> -->
                                        <div class="message appeared" style="top: 10%;" *ngFor="let message of messages; let i=index; let last = last"
                                            [ngStyle]="{'margin-top': i>0 ? '70px' : '0px'}"
                                            [ngClass]="{'right': message.sender == 'me', 'left': message.sender != 'me' }">
                                            <div class="avatar" 
                                                [ngStyle]="{'background-image': message.sender_avatar == null ? 'url(../assets/img/me.jpg)' : 'url(data:image/jpg;base64,'+message.sender_avatar+ ')' }"
                                                > </div>
                                            <div class="text_wrapper">
                                                <div class="text mt-7 mb-7" [ngClass]="{'urgent_msg': message.important,' ': !message.important}">{{message.message}}
                                                    <p class="text-left mb-0 mt-4" style="font-size: smaller;"
                                                    [ngClass]="{'text-dark': message.sender == 'me', 'text-default': message.sender != 'me' }">
                                                        <b>{{message?.sent_at | date: 'dd/MM/yyyy - HH:mm '}}</b>
                                                    </p>
                                                    <span *ngIf="message.important && last" class="text-right" style="font-size: smaller;">
                                                        <img src="assets/img/suivitim_img/important.gif" *ngIf="message.sender == 'me'" style="width: 20px;height: 20px;border: unset;">
                                                        <img src="assets/img/suivitim_img/important_other.gif" *ngIf="message.sender != 'me'" style="width: 20px;height: 20px;border: unset;">
                                                            <b> En attente de réponse !</b></span>
                                                </div>
                                            </div>
                                            <span class="mb-2 ml-2 badge badge-pills outline-badge-primary seeAt mt-1" 
                                                *ngIf="message.sender == 'me' && message.seen">
                                                {{message?.see_at | date: 'dd/MM/yyyy - HH:mm '}} <img src="assets/img/suivitim_img/commentSeen.gif"
                                                style="width: 20px;height: 20px;border: unset;"></span>
                                        </div>
                                    </ul>
                                    <div class="chat-bottom-section mt-3 clearfix">
                                        <div class="input-group mb-2 message_input_wrapper">
                                            <div class="input-group-prepend" id="msg_urgent">
                                                
                                            </div>
                                            <input type="text" class="message_input form-control" id="messageText" style="border-radius: 10px;"
                                                placeholder="Saisir votre message ...">
                                            <div class="input-group-append ml-0">
                                                <button class="input-group-text br-0" (click)="sendNewMessage(selectedCustomer?.customer)">Envoyer 
                                                    <i *ngIf="!sending" class="flaticon-send-fill-1"></i>
                                                    <img *ngIf="sending" src="../../../assets/img/envoyer-message-enveloppe.gif" alt="" width="25px">
                                                </button>
                                            </div>
                                            
                                            
                                        </div>
                                        <div class="custom-control rounded-chk custom-checkbox checkbox-primary">
                                            <input type="checkbox" class="custom-control-input" id="roundedChk2" checked="">
                                            <label class="custom-control-label" for="roundedChk2">J'attends la réponse</label>
                                        </div>
                                            
                                    </div>
                                </div>
                                <div class="message_template d-none">
                                    <div class="message">
                                        <div class="avatar"></div>
                                        <div class="text_wrapper">
                                            <div class="text"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
            <button type="button" class="btn btn-gradient-default btn-rounded mt-3 mb-4" data-dismiss="modal">Retour</button>
        </div>
        </div>
    </div>
</div>
